<script setup>
import { computed } from 'vue';
import { useI18n } from 'vue-i18n';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownContainer from 'next/dropdown-menu/base/DropdownContainer.vue';
import DropdownSection from 'next/dropdown-menu/base/DropdownSection.vue';
import DropdownBody from 'next/dropdown-menu/base/DropdownBody.vue';
import DropdownItem from 'next/dropdown-menu/base/DropdownItem.vue';

// 导入 SVG 图片
import documentPopoverLight from 'assets/images/dashboard/pilot/document-popover-light.svg';

const props = defineProps({
  assistants: {
    type: Array,
    required: true,
  },
  activeAssistant: {
    type: Object,
    required: true,
  },
});

const emit = defineEmits(['setAssistant']);

const { t } = useI18n();

const activeAssistantLabel = computed(() => {
  return props.activeAssistant
    ? props.activeAssistant.name
    : t('PILOT.COPILOT.SELECT_ASSISTANT');
});
</script>

<template>
  <div>
    <DropdownContainer>
      <template #trigger="{ toggle, isOpen }">
        <Button
          :label="activeAssistantLabel"
          icon="i-woot-captain"
          ghost
          slate
          xs
          :class="{ 'bg-n-alpha-2': isOpen }"
          @click="toggle"
        />
      </template>
      <DropdownBody class="bottom-9 min-w-72 z-50" strong>
        <!-- 顶部说明区域 -->
        <div class="px-3 pt-3 pb-2">
          <div class="flex items-center gap-3">
            <div
              class="flex-shrink-0 w-16 h-16 rounded-lg overflow-hidden bg-gradient-to-br from-n-purple-2 to-n-purple-4 dark:from-n-purple-8 dark:to-n-purple-9 flex items-center justify-center"
            >
              <img
                :src="documentPopoverLight"
                alt=""
                class="w-full h-full object-cover"
              />
            </div>
            <div class="flex-1 min-w-0">
              <p
                class="text-sm font-medium text-n-slate-12 dark:text-n-slate-1"
              >
                {{ t('PILOT.COPILOT.ASSISTANT_SWITCHER.TITLE') }}
              </p>
              <p class="text-xs text-n-slate-10 dark:text-n-slate-4 mt-0.5">
                {{ t('PILOT.COPILOT.ASSISTANT_SWITCHER.DESCRIPTION') }}
              </p>
            </div>
          </div>
        </div>

        <div class="border-t border-n-weak dark:border-n-strong" />

        <!-- 助手列表 -->
        <DropdownSection class="[&>ul]:max-h-80">
          <DropdownItem
            v-for="assistant in assistants"
            :key="assistant.id"
            class="!items-start !gap-1 flex-col cursor-pointer"
            @click="() => emit('setAssistant', assistant)"
          >
            <template #label>
              <div class="flex gap-1 justify-between w-full">
                <div class="items-start flex gap-1 flex-col">
                  <span class="text-n-slate-12 text-sm">
                    {{ assistant.name }}
                  </span>
                  <span class="line-clamp-2 text-n-slate-11 text-xs">
                    {{ assistant.description }}
                  </span>
                </div>

                <div
                  v-if="assistant.id === activeAssistant?.id"
                  class="flex items-center justify-center flex-shrink-0 w-4 h-4 rounded-full bg-n-slate-12 dark:bg-n-slate-11"
                >
                  <i
                    class="i-lucide-check text-white dark:text-n-slate-1 size-3"
                  />
                </div>
              </div>
            </template>
          </DropdownItem>
        </DropdownSection>
      </DropdownBody>
    </DropdownContainer>
  </div>
</template>
